enum CommunityRequestStatusType {
  DRAFT = '0',
  PENDING = '1',
  VALIDATED = '2',
  PUBLISHED = '3',
  DELETED = '4',
}

export default CommunityRequestStatusType
